import styled from "styled-components";

import { CTA, theme } from "@/component-library";

const StyledCloseCTA = styled(CTA)`
  position: absolute;
  right: ${theme.spacing.spacing2};
  top: 0;
`;

export { StyledCloseCTA };
